import React, { useEffect } from "react";
import "./Insights.css";
import AOS from "aos";
import "aos/dist/aos.css";

const articles = [
  {
    id: 1,
    title: "The Future of AI in Digital Marketing: 2026 Trends",
    category: "Market Trends",
    date: "March 12, 2026",
    excerpt: "Discover how generative AI and predictive analytics are reshaping consumer behavior and campaign optimization.",
    image: "/images/ai-future.jpg", // Placeholder path
    featured: true
  },
  {
    id: 2,
    title: "Mastering SEO: Beyond Keywords in the Semantic Era",
    category: "Growth Strategy",
    date: "March 10, 2026",
    excerpt: "Why topic authority and user intent have replaced simple keyword density in modern search algorithms.",
    image: "/images/seo-mastery.jpg"
  },
  {
    id: 3,
    title: "The Rise of Voice Search and its Impact on Brands",
    category: "Digital Innovation",
    date: "March 08, 2026",
    excerpt: "How to optimize your digital presence for the growing number of voice-activated dispositivo users.",
    image: "/images/voice search.png"
  },
  {
    id: 4,
    title: "Performance Marketing: Maximizing ROI in 2026",
    category: "Market Trends",
    date: "March 05, 2026",
    excerpt: "Advanced tactics for attribution modeling and cross-channel optimization in a privacy-first world.",
    image: "/images/performance.jpg"
  }
];

function Insights() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const featuredArticle = articles.find(a => a.featured);
  const regularArticles = articles.filter(a => !a.featured);

  return (
    <div className="insights-page">
      <div className="insights-container">
        {/* Header Section */}
        <header className="insights-header" data-aos="fade-up">
          <span className="accent-tag">Knowledge Hub</span>
          <h1>Industry <span className="highlight">Insights</span></h1>
          <p className="subtitle">
            Expert perspectives on the evolving digital landscape, market trends, and strategic growth.
          </p>
        </header>

        {/* Featured Article */}
        {featuredArticle && (
          <section className="featured-insight" data-aos="fade-up">
            <div className="featured-card">
              <div className="featured-image">
                <img src={featuredArticle.image} alt={featuredArticle.title} />
              </div>
              <div className="featured-content">
                <span className="category-badge">{featuredArticle.category}</span>
                <span className="date">{featuredArticle.date}</span>
                <h2>{featuredArticle.title}</h2>
                <p>{featuredArticle.excerpt}</p>
                <a href="#read" className="read-more">Read Full Article →</a>
              </div>
            </div>
          </section>
        )}

        {/* Article Grid */}
        <section className="articles-grid">
          {regularArticles.map((article, index) => (
            <div
              className="article-card"
              key={article.id}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="article-image">
                <img src={article.image} alt={article.title} />
                <span className="category-tag">{article.category}</span>
              </div>
              <div className="article-content">
                <span className="article-date">{article.date}</span>
                <h3>{article.title}</h3>
                <p>{article.excerpt}</p>
                <a href="#read" className="article-link">Continue Reading</a>
              </div>
            </div>
          ))}
        </section>


      </div>
    </div>
  );
}

export default Insights;
